// frontend/packages/business-console/src/pages/Pulse/sections/SectionShell.jsx
//
// Visual shell every Pulse section uses. Restyled onto the console
// redesign kit (Surface + tokens): a card with an uppercase section
// label header (the "Daily Brief" accent system), a consistent empty
// state, and an optional right-aligned action. The `icon` prop is still
// accepted for API compatibility but the redesign headers are
// label-only, so it's rendered small and muted when present.

import React from 'react';
import { Box, Typography } from '@mui/material';
import { Surface, useTokens } from '../../../components/primitives';

export default function SectionShell({
  title,
  subtitle,
  icon,
  action,
  empty,
  emptyCopy,
  children,
}) {
  const t = useTokens();
  return (
    <Surface
      radius="16px"
      sx={{
        p: { xs: 2.25, sm: 2.5 },
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
        }}
      >
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}
        >
          {icon ? (
            <Box
              sx={{
                color: t.faint,
                display: 'flex',
                alignItems: 'center',
                fontSize: 15,
              }}
            >
              {icon}
            </Box>
          ) : null}
          <Box sx={{ minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: 11,
                fontWeight: 800,
                letterSpacing: '.8px',
                textTransform: 'uppercase',
                color: t.faint,
                lineHeight: 1.3,
              }}
            >
              {title}
            </Typography>
            {subtitle ? (
              <Typography sx={{ fontSize: 11.5, color: t.muted, mt: 0.25 }}>
                {subtitle}
              </Typography>
            ) : null}
          </Box>
        </Box>
        {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
      </Box>

      {empty ? (
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            color: t.muted,
            py: 3,
          }}
        >
          <Typography sx={{ fontSize: 13, maxWidth: 280 }}>
            {emptyCopy ||
              "No data yet. Check back once you've sent your first invoice."}
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1.5 }}
        >
          {children}
        </Box>
      )}
    </Surface>
  );
}
